import React from "react";
import { Navigate } from "react-router-dom";
import { isTokenValid } from "../utils/auth";

export default function ProtectedRoute({ token, children }) {
  // If token is missing or expired, redirect to central landing page
  if (!token || !isTokenValid(token)) {
    return <Navigate to="/tractum" replace />;
  }

  // Token valid → render child components
  return children;
}
